import { render, staticRenderFns } from "./Anken.vue?vue&type=template&id=dcd8129a&scoped=true&"
import script from "./Anken.vue?vue&type=script&lang=js&"
export * from "./Anken.vue?vue&type=script&lang=js&"
import style0 from "./Anken.vue?vue&type=style&index=0&id=dcd8129a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd8129a",
  null
  
)

export default component.exports